var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import ConfigurationProvider from './service/Provider';
import ModelListFiltersUI from './ModelListFilters';
import isSSR from '../../utils/isSSR';
import useAppName from '../../utils/sitecoreContext/useAppName';
import { ACURA_SITE_NAME, HONDA_SITE_NAME, MARINE_SITE_NAME, PE_SITE_NAME, PSP_SITE_NAME } from '../../utils/constants';
import { variant1, variant2, variant3, variant4 } from './service/constants';
var ModelListFiltersMap = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var rendering = _a.rendering, props = __rest(_a, ["rendering"]);
    /** this component is part of /vehicles page, which is quite heavy.
     * One of the optimization is to remove ModelListFilters component
     * from App nodes tree for SSR to optimize app capacity.
     */
    var appName = useAppName();
    var categoryFilterLabel = '';
    var variant;
    var filterTypes = ((_d = (_c = (_b = props === null || props === void 0 ? void 0 : props.fields) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.filterType) || [];
    var singleSelectFilters = filterTypes === null || filterTypes === void 0 ? void 0 : filterTypes.filter(function (item) { var _a, _b; return ((_b = (_a = item === null || item === void 0 ? void 0 : item.enableSingleSelect) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.value) === true; }).map(function (item) { return item.filterCategory.fields.name; });
    switch (appName) {
        case HONDA_SITE_NAME:
        case ACURA_SITE_NAME:
            variant = variant1;
            break;
        case MARINE_SITE_NAME:
            variant = variant2;
            break;
        case PSP_SITE_NAME:
            variant = variant3;
            break;
        case PE_SITE_NAME:
            categoryFilterLabel =
                ((_h = (_g = (_f = (_e = filterTypes === null || filterTypes === void 0 ? void 0 : filterTypes.find(function (item) { return item.filterCategory.fields.name === 'productType'; })) === null || _e === void 0 ? void 0 : _e.filterCategory) === null || _f === void 0 ? void 0 : _f.fields) === null || _g === void 0 ? void 0 : _g.filterCategoryName) === null || _h === void 0 ? void 0 : _h.value) || '';
            filterTypes = filterTypes.filter(function (item) { return item.filterCategory.fields.name !== 'productType'; });
            variant = variant4;
            break;
        default:
    }
    var appNameConfig = useMemo(function () { return ({ variant: variant, filterTypes: filterTypes, categoryFilterLabel: categoryFilterLabel, singleSelectFilters: singleSelectFilters }); }, [variant, filterTypes, categoryFilterLabel, singleSelectFilters]);
    if (isSSR()) {
        return null;
    }
    return (React.createElement(ConfigurationProvider, { appNameConfig: appNameConfig },
        React.createElement(ModelListFiltersUI, __assign({ componentName: rendering === null || rendering === void 0 ? void 0 : rendering.componentName }, props))));
};
export default ModelListFiltersMap;
